import axiosClient from './axiosClient';

export const fetchGameChallenges = async (gameId) => {
  if (!gameId) {
    // console.error('Game ID is required to fetch challenges.');
    // Or throw new Error('Game ID is required'); depending on how you want to handle it
    return null; // Return null or an empty object/array
  }
  try {
    // Assuming the endpoint expects the id in the request body for a POST request
    // Adjust if it expects a GET request or different parameter name/location
    const response = await axiosClient.post('/v1/challenges/game/all', { id: gameId });
    
    if (response.data && response.data.success) {
      // console.log('API Response:', response.data); // Log the full response
      // Ensure the structure matches what the component expects
      // It seems the component expects gameData.gameName and gameData.challenges
      return response.data.data; 
    } else {
      // console.error('Failed to fetch game challenges:', response.data ? response.data.error : 'No response data');
      return null; // Indicate failure
    }
  } catch (error) {
    // console.error('Error fetching game challenges:', error);
    // Handle network errors or other exceptions
    return null; // Indicate failure
  }
};

export const fetchDayChallengesHistory = async (day) => {
  if (!day) {
    // console.error('Day is required to fetch historical challenges.');
    return null;
  }
  try {
    const response = await axiosClient.post('/v1/daily-challenges/history', { day });
    // console.log('API Eesponse:', response.data);
    if (response.data && response.data.status) {
      return response.data;
    } else {
      // console.error('Failed to fetch historical challenges:', response.data ? response.data.error : 'No response data');
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const submitGamingTaskEntry = async (entryImage, gameId, challengeId) => {
  try {
    const response = await axiosClient.post('/v1/challenge/entry', {
      entryImage,
      gameId,
      challengeId,
    });
    return response.data;
  } catch (error) {
    // console.error('Error submitting gaming task entry:', error);
    throw error;
  }
};

export const fetchCompletedTasks = async () => {
  try {
    const response = await axiosClient.post('/v1/completed-task/get');
    if (response.data && response.data.success) {
      return response.data;
    } else {
      // console.error('Failed to fetch completed tasks:', response.data ? response.data.error : 'No response data');
      return null;
    }
  } catch (error) {
    // console.error('Error fetching completed tasks:', error);
    return null;
  }
};